(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .factory("checkoutResource", ["$resource", checkoutResource]);
    function checkoutResource($resource) {
        return $resource("api/checkout/:action/:actionValue", { actionValue: "@actionValue" }, {
            calculateTaxes: {
                method: "POST",
                params: { action: "calculate-taxes" }
            },
            pay: {
                method: "POST",
                params: { action: "pay" }
            },
            confirmPayPalExpressCheckoutPayment: {
                method: "POST",
                params: { action: "confirm-paypal-express-checkout" }
            },
            complete: {
                method: "POST",
                params: { action: "complete" }
            },
            processMonerisPaymentResponse: {
                method: "POST",
                params: { action: "processMonerisPaymentResponse" }
            },
            //getMonerisHostedPayPageDetails: {
            //	method: "GET",
            //	params: { action: "getMonerisHostedPayPageDetails" }
            //},
            getBamboraUrl: {
                method: "GET",
                params: { action: "getBamboraUrl" }
            },
            processBamboraPaymentFormResponse: {
                method: "POST",
                params: { action: "processBamboraPaymentFormResponse" }
            },
            getAffiniPayUrl: {
                method: "GET",
                params: { action: "getAffiniPayUrl" }
            },
            getStripeCheckoutUrl: {
                method: "GET",
                params: { action: "getStripeCheckoutUrl" }
            },
            generateMonerisToken: {
                method: "POST",
                params: { action: "moneris-preload" }
            },
            makeMonerisReceiptRequest: {
                method: "POST",
                params: { action: "moneris-receipt" }
            },
            sendTaxExemptVerificationEmail: {
                method: "POST",
                params: { action: "sendTaxExemptVerificationEmail" }
            },
            verifyTaxExemptCode: {
                method: "POST",
                params: { action: "verifyTaxExemptCode" }
            }
        });
    }
}());
